import React, {useEffect} from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {GetCurrentLocale, scrollToId} from "../../components/Utils";
import CartSummary from "./CartSummary";
import OfferRequestPage from "../Offer/OfferRequestPage";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/RootReducer";
import {LocalParams} from "../../components/LocalParams";
import {getUserCatalog} from "../User/UsersSlice";

interface ComponentProps{
  setActiveStep: any
  activeStep: number,
}

const CartPage: React.FC<ComponentProps> = ({setActiveStep, activeStep}:ComponentProps) => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)
  const dispatch = useDispatch();
  const token = LocalParams.getItem("token");
  useEffect(() => {
    if(token !== null){
      dispatch(getUserCatalog(token))
    }
  }, []);
  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);
  const itemsInCart = useSelector((state: RootState) => state.cartRdc.cart )

  return (
    <div className="page slide-page active">
      <div className="container clearfix">
        <div className="row card mb-4">
          <div className="content-body">
            <CartSummary activeStep={activeStep}/>
            {
              itemsInCart && itemsInCart.items && itemsInCart.items.length > 0 ?
                <OfferRequestPage/>
                :
                null
            }
          </div>
        </div>
        {
          itemsInCart && itemsInCart.items && itemsInCart.items.length > 0 ?
            <>
              <div className="float-end">
                <button className="btn btn-primary float-end" onClick={() => [isAuthenticated ? setActiveStep(activeStep + 2) : setActiveStep(activeStep + 1), scrollToId("topPage")]}>{ t('go_next_step') }</button>
              </div>
            </>
            : null
        }
      </div>
    </div>
  )
}

export default CartPage;
